// 🛸 PREMIUM SKY FLEET — vehicle SVGs (paintable) + per-vehicle flight physics.

export const VEHICLE_PAINT = {
  classic: null,
  crimson: { main: "#ef4444", light: "#fca5a5", dark: "#991b1b" },
  gold: { main: "#f59e0b", light: "#fde68a", dark: "#92400e" },
  emerald: { main: "#10b981", light: "#6ee7b7", dark: "#065f46" },
  sky: { main: "#0ea5e9", light: "#7dd3fc", dark: "#075985" },
  violet: { main: "#8b5cf6", light: "#c4b5fd", dark: "#4c1d95" },
  pink: { main: "#ec4899", light: "#f9a8d4", dark: "#9d174d" },
};

export const HotAirBalloonSvg = ({ w = 72, tint = null }) => {
  const c = tint || { main: "#f97316", light: "#fbbf24", dark: "#ef4444" };
  return (
    <svg width={w} height={w * 1.3} viewBox="0 0 60 78" style={{ filter: "drop-shadow(0 0 12px rgba(249,115,22,0.45))" }}>
      <ellipse cx="30" cy="24" rx="24" ry="24" fill={c.dark} />
      <path d="M14 24 Q30 -4 46 24 Q30 52 14 24" fill={c.main} opacity="0.85" />
      <path d="M22 24 Q30 0 38 24 Q30 48 22 24" fill={c.light} />
      <ellipse cx="22" cy="15" rx="4" ry="7" fill="white" opacity="0.3" />
      <line x1="18" y1="44" x2="24" y2="60" stroke="#78350f" strokeWidth="1.4" />
      <line x1="42" y1="44" x2="36" y2="60" stroke="#78350f" strokeWidth="1.4" />
      <rect x="22" y="60" width="16" height="12" rx="2.5" fill="#92400e" />
      <rect x="22" y="60" width="16" height="4" rx="2" fill="#b45309" />
    </svg>
  );
};

export const DroneSvg = ({ w = 64, tint = null }) => {
  const c = tint || { main: "#0ea5e9", light: "#38bdf8", dark: "#0f172a" };
  return (
    <svg width={w} height={w * 0.7} viewBox="0 0 64 44" style={{ filter: "drop-shadow(0 0 10px rgba(14,165,233,0.5))" }}>
      <ellipse cx="10" cy="8" rx="9" ry="2.5" fill="#94a3b8" opacity="0.85" />
      <ellipse cx="54" cy="8" rx="9" ry="2.5" fill="#94a3b8" opacity="0.85" />
      <line x1="14" y1="10" x2="27" y2="20" stroke="#475569" strokeWidth="2.5" />
      <line x1="50" y1="10" x2="37" y2="20" stroke="#475569" strokeWidth="2.5" />
      <rect x="24" y="17" width="16" height="12" rx="4" fill={c.main} />
      <circle cx="32" cy="23" r="3.5" fill="#0f172a" />
      <circle cx="32" cy="23" r="1.6" fill={c.light} />
      <rect x="27" y="29" width="10" height="3" rx="1.5" fill="#334155" />
    </svg>
  );
};

export const UfoSvg = ({ w = 70, tint = null }) => {
  const c = tint || { main: "#94a3b8", light: "#7dd3fc", dark: "#64748b" };
  return (
    <svg width={w} height={w * 0.9} viewBox="0 0 70 63" style={{ filter: "drop-shadow(0 0 14px rgba(163,230,53,0.55))" }}>
      <path d="M22 30 L35 62 L48 30 Z" fill="#a3e635" opacity="0.18" />
      <ellipse cx="35" cy="16" rx="12" ry="10" fill={tint ? c.light : "#7dd3fc"} opacity="0.9" />
      <ellipse cx="31" cy="12" rx="3.5" ry="4" fill="white" opacity="0.5" />
      <ellipse cx="35" cy="25" rx="30" ry="10" fill={c.dark} />
      <ellipse cx="35" cy="22" rx="30" ry="8" fill={c.main} />
      <circle cx="15" cy="26" r="2.4" fill="#fbbf24" />
      <circle cx="28" cy="29" r="2.4" fill="#4ade80" />
      <circle cx="42" cy="29" r="2.4" fill="#fbbf24" />
      <circle cx="55" cy="26" r="2.4" fill="#4ade80" />
    </svg>
  );
};

export const BlimpSvg = ({ w = 120, tint = null }) => {
  const c = tint || { main: "#8b5cf6", light: "#a78bfa", dark: "#7c3aed" };
  return (
    <svg width={w} height={w * 0.45} viewBox="0 0 120 54" style={{ filter: "drop-shadow(0 0 14px rgba(139,92,246,0.5))" }}>
      <ellipse cx="64" cy="22" rx="52" ry="18" fill={c.main} />
      <ellipse cx="64" cy="18" rx="52" ry="13" fill={c.light} opacity="0.6" />
      <path d="M20 12 L2 4 L6 22 L2 40 L20 32 Z" fill={c.dark} />
      <ellipse cx="90" cy="14" rx="10" ry="4" fill="white" opacity="0.3" />
      <rect x="50" y="38" width="28" height="10" rx="4" fill="#1e293b" />
      <line x1="56" y1="36" x2="56" y2="40" stroke="#1e293b" strokeWidth="2" />
      <line x1="72" y1="36" x2="72" y2="40" stroke="#1e293b" strokeWidth="2" />
      <circle cx="56" cy="43" r="1.6" fill="#fbbf24" />
      <circle cx="64" cy="43" r="1.6" fill="#fbbf24" />
      <circle cx="72" cy="43" r="1.6" fill="#fbbf24" />
    </svg>
  );
};

export const RocketSvg = ({ w = 56, tint = null }) => {
  const c = tint || { main: "#ef4444", light: "#7dd3fc", dark: "#0ea5e9" };
  return (
    <svg width={w} height={w * 1.55} viewBox="0 0 44 68" style={{ filter: "drop-shadow(0 0 14px rgba(244,63,94,0.55))" }}>
      <path d="M22 2 Q34 18 32 40 L12 40 Q10 18 22 2" fill="#e2e8f0" />
      <path d="M22 2 Q28 16 28 40 L22 40 Z" fill="#cbd5e1" />
      <circle cx="22" cy="22" r="6" fill={c.dark} />
      <circle cx="22" cy="22" r="3.4" fill={c.light} />
      <path d="M12 34 L2 48 L12 44 Z" fill={c.main} />
      <path d="M32 34 L42 48 L32 44 Z" fill={c.main} />
      <rect x="17" y="40" width="10" height="5" rx="2" fill={c.main} />
      <path d="M17 46 Q22 66 27 46 Z" fill="#f97316" />
      <path d="M19 46 Q22 58 25 46 Z" fill="#fbbf24" />
    </svg>
  );
};

export const PlaneSvg = ({ w = 96, tint = null }) => {
  const c = tint || { main: "#ef4444", light: "#fca5a5", dark: "#991b1b" };
  return (
    <svg width={w} height={w * 0.42} viewBox="0 0 100 42" style={{ filter: "drop-shadow(0 0 12px rgba(226,232,240,0.45))" }}>
      <ellipse cx="52" cy="24" rx="38" ry="9" fill={c.main} />
      <ellipse cx="52" cy="21" rx="38" ry="6" fill={c.light} opacity="0.55" />
      <path d="M18 20 L6 8 L14 24 Z" fill={c.dark} />
      <path d="M16 24 L4 30 L16 29 Z" fill={c.dark} />
      <path d="M46 22 L30 40 L52 28 Z" fill={c.dark} />
      <path d="M48 20 L38 6 L58 18 Z" fill={c.main} opacity="0.9" />
      <circle cx="70" cy="22" r="3" fill="#0f172a" />
      <circle cx="60" cy="22" r="3" fill="#0f172a" />
      <circle cx="80" cy="23" r="3" fill="#0f172a" />
      <path d="M90 24 L99 20 L99 28 Z" fill="#cbd5e1" />
      <ellipse cx="92" cy="24" rx="1.6" ry="7" fill="#94a3b8" opacity="0.8" />
    </svg>
  );
};

export const VEHICLE_ART = { hot_air: HotAirBalloonSvg, drone: DroneSvg, ufo: UfoSvg, rocket: RocketSvg, blimp: BlimpSvg, plane: PlaneSvg };

// Flight physics per ride: hot air = slow & regal, drone = fast zigzag, ufo = hover-wobble,
// rocket = straight-up blast, blimp = horizontal flyover, plane = brisk banner tow.
export const VEHICLE_FLIGHT = {
  hot_air: { dur: 38, sway: 10, rotate: 1, w: 76 },
  drone: { dur: 13, sway: 60, rotate: 6, w: 60 },
  ufo: { dur: 24, sway: 36, rotate: 4, w: 68 },
  rocket: { dur: 8, sway: 0, rotate: 0, w: 54 },
  blimp: { dur: 48, horizontal: true, w: 124 },
  plane: { dur: 22, horizontal: true, w: 96 },
};
